module.exports = __webpack_public_path__ + "static/media/404.1d5e3344.webp";